module.exports = __webpack_public_path__ + "2a59e8693c0fd9fe1853f6063257573a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/gamers-paradise-main.png
// module id = 570
// module chunks = 0